/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownMinorityGroup } from '../models/db_DropdownMinorityGroup';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MinorityGroups {
    /**
     * Get a list of minority groups
     * @returns db_DropdownMinorityGroup OK
     * @throws ApiError
     */
    public static listMinorityGroups(): CancelablePromise<Array<db_DropdownMinorityGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/minority-groups',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
